// Typed event catalog + closed per-event property allowlist for landing
// analytics. Mirrors the app catalog (apps/client/src/data/hooks/
// analytics-events.ts) and the server allowlist:
//   - captureEvent only accepts a KNOWN event name, so the taxonomy can't drift
//     (no `waitlist_submit` vs `waitlist_submitted`, no `utm_source` typos).
//   - a property not listed for its event is DROPPED before egress
//     (defense-in-depth — no PII/financial value can leak even if a caller
//     passes one).
// PostHog built-ins ($pageview, $pageleave, $autocapture, web vitals) are not
// governed here — only our explicit captureEvent calls.
export const LANDING_EVENT_ALLOWLIST = {
  // Waitlist funnel. `outcome` is success|exists|error; `has_referral` a bool.
  waitlist_started: new Set<string>([]),
  waitlist_submitted: new Set<string>(["outcome", "has_referral"]),
} as const;

export type LandingAnalyticsEvent = keyof typeof LANDING_EVENT_ALLOWLIST;

/** Drop-unless-listed. Returns only the allowlisted keys, or undefined when
 * there is nothing to send. */
export function scrubEventProps(
  event: LandingAnalyticsEvent,
  props?: Record<string, unknown>,
): Record<string, unknown> | undefined {
  if (!props) return undefined;
  const allow = LANDING_EVENT_ALLOWLIST[event];
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(props)) {
    if (allow.has(key)) out[key] = value;
  }
  return out;
}
